import { AssessmentMethodType } from '@schooly/api';

export const shouldDisableScoreInPercentage = (
  assessments: { methods: { method_type: AssessmentMethodType }[] }[],
) => {
  return !assessments.some((assessment) =>
    assessment.methods.some((method) => method.method_type === AssessmentMethodType.Score),
  );
};
